import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";
import {
  fetchEventInfo,
  fetchOpenBets,
  clearExchcngeBets,
  setBetSlipOddsChangeMsg,
  setUpdateEventMarketsWS,
  fetchPremiumEventInfo,
} from "../../store";
import { useParams } from "react-router-dom";
import { EventData } from "../../models/EventData";
import AllMarketsPage from "../../pages/AllMarketsPage/AllMarketsPage";
import SportRadarMatchOdds from "../../components/SportRadarMarket/SportRadarMatchOdds";
import { BsData } from "../../models/BsData";
import MarketPremium from "../../pages/AllMarketsPage/MarketPremium";
import "./MarketView.scss";

type StoreProps = {
  fetchEventInfo: (sportId, eventId) => void;
  fetchOpenBets: (eventId, sportId) => void;
  setUpdateEventMarketsWS: (eventInfo: EventData) => void;
  providerId: string;
  clearExchangeBets: () => void;
  bets: BsData[];
  lobbyType: string;
  fetchPremiumEventInfo: (eventId, sportId, refresh) => void;
  premiumEventInfo: EventData;
};

const MarketView: React.FC<StoreProps> = (props) => {
  const {
    bets,
    setUpdateEventMarketsWS,
    fetchEventInfo,
    providerId,
    fetchOpenBets,
    clearExchangeBets,
    lobbyType,
    fetchPremiumEventInfo,
    premiumEventInfo,
  } = props;

  const { sportId, eventId } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (sportId && eventId && !lobbyType?.toLowerCase().includes("premium") &&
      !window.location.pathname.includes("premium/")) {
      fetchEventInfo(sportId, eventId);
    }
  }, [eventId, sportId, lobbyType]);

  useEffect(() => {
    if (
      lobbyType?.toLowerCase().includes("premium") ||
      window.location.pathname.includes("premium/")
    ) {
      fetchPremiumEventInfo(sportId, eventId, true);
    }
  }, [eventId]);

  useEffect(() => {
    if (!lobbyType?.toLowerCase().includes("premium") && providerId !== "SportRadar") {
      let refreshInterval = setInterval(() => {
        fetchOpenBets(eventId, sportId);
      }, 15 * 1000);
      return () => {
        clearInterval(refreshInterval);
      };
    }
  }, []);

  useEffect(() => {
    // if (premiumEventInfo?.markets?.matchOdds?.length) {
    if (
      lobbyType?.toLowerCase().includes("premium") ||
      window.location.pathname.includes("premium/")
    ) {
      let refreshInterval = setInterval(() => {
        fetchPremiumEventInfo(sportId, eventId, false);
      }, 60 * 1000);
      return () => {
        clearInterval(refreshInterval);
      };
    }
    // }
  }, [premiumEventInfo]);

  return (
    <>
      {lobbyType?.toLowerCase().includes("premium") ||
      window.location.pathname.includes("premium/") ? (
        <MarketPremium />
      ) : providerId === "SportRadar" ? (
        <SportRadarMatchOdds />
      ) : (
        <AllMarketsPage />
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    eventInfo: state.sportsBook.eventInfo,
    providerId: state.auth.providerId,
    bets: state.betslip.bets,
    lobbyType: state.auth.lobbyType,
    premiumEventInfo: state.sportsBook.premiumEventInfo,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchEventInfo: (sportId: string, eventId: string) =>
      dispatch(fetchEventInfo(sportId, eventId)),
    fetchPremiumEventInfo: (sportId: string, eventId: string, refresh: boolean) =>
      dispatch(fetchPremiumEventInfo(sportId, eventId, refresh)),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    setBetSlipOddsChangeMsg: (flag: boolean) =>
      dispatch(setBetSlipOddsChangeMsg(flag)),
    setUpdateEventMarketsWS: (eventInfo: EventData) =>
      dispatch(setUpdateEventMarketsWS(eventInfo)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MarketView);
